import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { IYOrHMudelResponse } from "../../../dto/converters/IYOrHMudelResponse";
import { TranslatorService } from "../../../services/translator-service";
import {useTranslation} from 'react-i18next';

const HMudelSingle = () => {
    
    const [hMudelFormInputData, setHMudelFormInputData] = useState({ dirEh2000ToLas20005: true, x: "", y: "", h: ""});
    const [resultFromApi, setResultFromApi] = useState(null as IYOrHMudelResponse | null);
    const {t} = useTranslation();

    const queryToApi = async (params: {x: string, y: string, h: string, dirEh2000ToLas20005: boolean}) => {
        let result = await TranslatorService.queryApiGet<IYOrHMudelResponse>(
            "/hmudel",
            params
        );
        setResultFromApi(result.data!);
    }

    function hasNotValidValues() {
        if (hMudelFormInputData.x === "" || hMudelFormInputData.y === "" || hMudelFormInputData.h === "") {
            return true;
        }
        
        return isNaN(Number(hMudelFormInputData.x)) || isNaN(Number(hMudelFormInputData.y)) || isNaN(Number(hMudelFormInputData.h));
    }

    return (
        <>
            <Form.Group className="mb-3">
            <Row>
                    <Col>
                        <Form.Check type="radio" name="singleLocalForm" aria-label="eh2000-las20005-yks" label={t('directionEH2000ToLAS20005')} defaultChecked onChange={e => {setHMudelFormInputData({ ...hMudelFormInputData, dirEh2000ToLas20005: true }); setResultFromApi(null)}} />
                    </Col>
                    <Col>
                        <Form.Check type="radio" name="singleLocalForm" aria-label="las20005-eh2000-yks" label={t('directionLAS20005ToEH2000')} onChange={e => {setHMudelFormInputData({ ...hMudelFormInputData, dirEh2000ToLas20005: false }); setResultFromApi(null)}} />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        x<sub>L-EST97 või LKS-92 TM</sub> {t('or')} B<sub>EUREF-EST97 või LKS-92</sub>*<Form.Control onChange={e => setHMudelFormInputData({ ...hMudelFormInputData, x: e.target.value })} type="text" size="sm" name="x" />
                    </Col>
                    <Col>
                        y<sub>L-EST97 või LKS-92 TM</sub> {t('or')} L<sub>EUREF-EST97 või LKS-92</sub>*<Form.Control onChange={e => setHMudelFormInputData({ ...hMudelFormInputData, y: e.target.value })} type="text" size="sm" name="y" />
                    </Col>
                    <Col>
                        {hMudelFormInputData.dirEh2000ToLas20005 ? <>H<sub>EH2000</sub></> : <>H<sub>LAS-2000,5</sub></>}
                        <Form.Control onChange={e => setHMudelFormInputData({ ...hMudelFormInputData, h: e.target.value })} type="text" size="sm" name="h" />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {t('coordsInDec')}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button 
                            onClick={(e) => {e.preventDefault(); queryToApi(hMudelFormInputData);}} 
                            type="submit" 
                            disabled={hasNotValidValues()}
                            aria-label="arvuta"
                        >
                            {t('calculateButtonLabel')}
                        </Button>
                    </Col>
                </Row>
            </Form.Group>
            {resultFromApi != null &&
                <>
                    {(resultFromApi.h && typeof(resultFromApi.h) !== "string") ? 
                    <>{t('answer')}: <b>{hMudelFormInputData.dirEh2000ToLas20005 ? <>H<sub>LAS-2000,5</sub></> : 
                    <>H<sub>EH2000</sub></>}</b> = {resultFromApi.h.toFixed(3)}</> : <><br />{t('outsideModelArea')}</>}
                </>
            }
            <br /><br /><br />
        </> 
    );

}

export default HMudelSingle;

